import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .LoginForm {
    width: 100%;
    padding: 30px 0;
    text-align: center;

    span {
      display: block;
      text-align: left;
    }

    strong {
      display: block;
      text-align: left;
    }

    .DefaultButton__text {
      text-align: center;
    }

    .LoginForm__submit-button {
      width: 100%;
      line-height: 2.4rem;
    }
    .ForgotPass__inner {
      text-align: left;
      margin-bottom: 29px;
      margin-top: -31px;
      display: flex;
      gap: 15px;
      flex-direction: column;
      align-items: flex-end;

      a {
        font-size: 14px;
        position: relative;
        padding-bottom: 1px;
        width: fit-content;

        &:last-child {
          margin: 0;
        }

        &:active {
          transform: translateY(2px);

          &:after {
            transform: scale(0);
          }
        }

        &:hover {
          &:after {
            transform: scale(0);
          }
        }

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          transform: scale(0.99);
          transition: all 0.4s ease;
          opacity: 0.4;
        }
      }
    }

    &__inputs-inner {
      .CheckboxField {
        text-align: left;
      }
    }

    .LoginForm__agreement-checkbox {
      margin: 0 0 12px 0;
      text-align: left;
      display: flex;
      align-items: flex-start;

      input[type='checkbox'] {
        display: none;
      }

      .login-agreement-label {
        display: flex !important;
        align-items: center;
        cursor: pointer;
        user-select: none;
        font-size: 13px;
        line-height: 18px;
        color: #333;
        position: relative;
      }

      .login-agreement-check-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        min-width: 20px;
        flex-shrink: 0;
        border: 1px solid #999;
        border-radius: 3px;
        margin-right: 8px;
        transition: all 0.2s ease;

        svg {
          width: 14px;
          height: 11px;
          fill: none;
          stroke: #ffffff;
          stroke-width: 2;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 16px;
          stroke-dashoffset: 16px;
          transition: all 0.3s ease;
          transition-delay: 0.1s;
        }
      }

      input[type='checkbox']:checked ~ .login-agreement-label .login-agreement-check-box {
        background: #4500e2;
        border-color: #4500e2;

        svg {
          stroke-dashoffset: 0;
        }
      }

      .login-agreement-check-box:hover {
        border-color: #4500e2;
      }

      .login-agreement-check-text {
        display: inline !important;
        text-align: left;

        a {
          color: #4500e2;
          text-decoration: underline;
          font-weight: 500;

          &:hover {
            color: #6a3ae8;
          }
        }
      }
    }

    #telegramAuthWrapper {
      margin-top: 25px;
    }
  }

  /* Notice弹窗样式 */
  .notice-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
  }

  .notice-modal {
    background-color: #ffffff;
    width: 400px;
    max-width: 90vw;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);
    text-align: center;
  }

  .notice-modal-header h3 {
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 20px 0;
    color: #000;
  }

  .notice-modal-body p {
    font-size: 15px;
    line-height: 1.5;
    color: #555;
    margin: 0 0 25px 0;
    text-align: center;
  }

  .notice-modal-footer {
    display: flex;
    justify-content: center;
  }

  .notice-modal-footer .DefaultButton {
    min-width: 100px;
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .LoginForm {
      .ForgotPass__inner {
        a {
          color: ${colors.secondary.hex};
          &:hover {
            color: ${colors.primary.hex};
            &:after {
              background-color: ${colors.primary.hex};
            }
          }
          &:after {
            background-color: ${colors.secondary.hex};
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
